<template>
  <span>
    <gl-button @click="$refs.file.click()">ファイル読込</gl-button>

    <!-- ファイル選択の表示は隠して、他トリガーからファイル選択ダイアログは起動します -->
    <input
      type="file"
      ref="file"
      hidden
      @change="search($event.target.files)"
    />
    <md-snackbar
      md-position="center"
      :md-duration="snackbar.duration"
      :md-active.sync="snackbar.show"
      md-persistent
    >
      <span>{{ snackbar.message }}</span>
    </md-snackbar>
  </span>
</template>

<script>
import { readAsText } from '@/util/localfile'

export default {
  props: {
    company: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * Snackbarプロパティ
       */
      snackbar: {
        show: false,
        duration: 4000,
        message: '',
      },
    }
  },
  methods: {
    async search(files) {
      if (files.length === 0) {
        return
      }

      const content = await readAsText(files[0])
      const codes = content
        .split('\n')
        .map(v => v.trim())
        .filter(v => v)

      const items = await this.$repositories
        .get('item')
        .getByCode(this.company, codes)

      this.showSnackbar({
        message: codes.length + '件中 ' + items.length + '商品見つかりました',
      })

      this.$emit('selected', items)
    },
    /**
     * Snackbarの表示
     */
    showSnackbar(options) {
      this.snackbar.duration = 4000
      this.snackbar.message = options.message
      this.snackbar.show = true
    },
  },
}
</script>
